import axios from 'axios';
import { Users_Cuentas } from 'generated/graphql';

export interface IProfesorName {
	key: string;
	tipoUsuario: string;
	rol: string;
	email: string;
	password: string;
	nombre: string;
	apellido: string;
	rut: string | null;
	fechaNacimiento: Date | null;
	genero: string | null;
	avatarPath: string | null;
	pais: string;
	colegio?: string;
}

export const fetchGetProfesorDetail = async (profesorKey: string, isPWA?: boolean): Promise<Users_Cuentas> => {
	const url = `${process.env.REACT_APP_NEST_BACKEND_URL}/profesor/detail/${profesorKey}${
		isPWA !== undefined ? `?isPWA=${isPWA}` : ''
	}`;
	const resp = await axios.get(url);
	return resp.data;
};

export const fetchGetProfesorName = async (profesorKey: string): Promise<IProfesorName> => {
	const resp = await axios.get(`${process.env.REACT_APP_NEST_BACKEND_URL}/profesor/${profesorKey}`);
	return resp.data;
};
